module.exports = __webpack_public_path__ + "static/media/good-sale-amount.f751a570.svg";